export default {
    name: "Message",
    title: "Message",
    icon: "mdi-message-processing-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            message: "",
            type: "info"
        };
    },
};